module.exports = __webpack_public_path__ + "static/img/dkz-img1.12614deb.jpeg";